import React from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { PageHeader, ResponsiveTable, TableSkeleton, EmptyState, StatusBadge } from "@/admin/ui";

export default function AdminCredits() {
  const [packs, setPacks] = React.useState(null);
  const load = () => api.get("/api/admin/credit-packs").then((r) => setPacks(r.data.items));
  React.useEffect(() => { load(); }, []);

  const save = async (pack, field, value) => {
    const payload = { [field]: field === "credits" || field === "price" ? Number(value) : value };
    try { await api.put(`/api/admin/credit-packs/${pack.id}`, payload); toast.success("Updated"); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };

  return (
    <div className="space-y-6" data-testid="admin-credits-page">
      <PageHeader title="Credit packs" description="Adjust pricing and volume for each credit pack. Changes take effect immediately for new purchases." />
      {!packs ? <TableSkeleton rows={4} cols={5} /> : packs.length === 0 ? (
        <EmptyState title="No credit packs configured" />
      ) : (
        <ResponsiveTable minWidth={640}>
          <thead className="lp-table-sticky"><tr>
            <th>Name</th><th>Credits</th><th>Price ($)</th><th>Popular</th><th>Active</th>
          </tr></thead>
          <tbody>
            {packs.map((p) => (
              <tr key={p.id} data-testid={`admin-pack-${p.name.toLowerCase()}`}>
                <td className="text-white/85">{p.name}</td>
                <td>
                  <input className="lp-input py-1 max-w-[140px] tabular-nums" value={p.credits}
                    onChange={(e) => setPacks(packs.map((x) => x.id === p.id ? { ...x, credits: e.target.value } : x))}
                    onBlur={(e) => save(p, "credits", e.target.value)} />
                </td>
                <td>
                  <input className="lp-input py-1 max-w-[110px] tabular-nums" value={p.price}
                    onChange={(e) => setPacks(packs.map((x) => x.id === p.id ? { ...x, price: e.target.value } : x))}
                    onBlur={(e) => save(p, "price", e.target.value)} />
                </td>
                <td>
                  <button className="focus:outline-none" onClick={() => save(p, "popular", !p.popular)}>
                    <StatusBadge tone={p.popular ? "warning" : "neutral"}>{p.popular ? "yes" : "no"}</StatusBadge>
                  </button>
                </td>
                <td>
                  <button className="focus:outline-none" onClick={() => save(p, "active", !p.active)}>
                    <StatusBadge tone={p.active ? "success" : "danger"}>{p.active ? "yes" : "no"}</StatusBadge>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </ResponsiveTable>
      )}
    </div>
  );
}
